import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import React, { useState } from "react";

import LanguageHolderItem from "./LanguageHolderItem";
import LanguageIcon from "@mui/icons-material/Language";

const LanguageHolder = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const languages = [
    {
      title: "Srpski",
      language: "sr",
      icon: "/images/sr.png",
    },
    {
      title: "Engleski",
      language: "en",
      icon: "/images/en.png",
    },
    {
      title: "Hrvatski",
      language: "hr",
      icon: "/images/hr.png",
    },
    {
      title: "Mađarski",
      language: "hu",
      icon: "/images/hu.png",
    },
    {
      title: "Makedonski",
      language: "mk",
      icon: "/images/mk.png",
    },
    {
      title: "Albanski",
      language: "al",
      icon: "/images/al.png",
    },
    {
      title: "Bosanski",
      language: "ba",
      icon: "/images/ba.png",
    },
    {
      title: "Slovenački",
      language: "sl",
      icon: "/images/sl.png",
    },
    {
      title: "Bugarski",
      language: "bg",
      icon: "/images/bg.png",
    },
  ];

  // Otvori meni
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Zatvori meni
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className="mr-2">
      <IconButton
        size="large"
        aria-label="show more"
        aria-haspopup="true"
        color="inherit"
        className="icon-header-color"
        onClick={handleClick}
      >
        <LanguageIcon />
      </IconButton>

      {/* Dropdown meni */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {languages?.map((language, index) => (
          <LanguageHolderItem
            handleClose={handleClose}
            title={language?.title}
            language={language?.language}
            icon={language?.icon}
          />
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageHolder;
